export default [
  {
    "bond_insurer": "AGC FORMERLY CIFG",
    "count": 7,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "AGC FORMERLY CIFG REINSURED BY ASSURED GTY CORP",
    "count": 24,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "AGC FORMERLY CIFG/SECD MKT AGMC FORM FSA",
    "count": 1,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "AGC REINSURES SECD MKT SYNCORA GUAR (FORM XLCA)",
    "count": 5,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "AGC REINSURES SYNCORA GUAR INC (FORM XLCA)",
    "count": 309,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "AGM",
    "count": 2,
    "Abbreviation": "AGM"
  },
  {
    "bond_insurer": "AGMC",
    "count": 17,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "AGMC FORMERLY FSA",
    "count": 2956,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "AGMC FORMERLY FSA (FORMERLY CGIC)",
    "count": 6,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "AGMC FORMERLY FSA/SECONDARY BHAC",
    "count": 8,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "AMBAC",
    "count": 1539,
    "Abbreviation": "AMBAC"
  },
  {
    "bond_insurer": "AMBAC (FORMERLY CONNIE LEE)",
    "count": 3,
    "Abbreviation": "AMBAC"
  },
  {
    "bond_insurer": "AMBAC/SECD MKT AGMC FORM FSA",
    "count": 35,
    "Abbreviation": "AMBAC"
  },
  {
    "bond_insurer": "AMBAC/SECD MKT AGMC FORM FSA/SECD MKT BHAC",
    "count": 1,
    "Abbreviation": "AMBAC"
  },
  {
    "bond_insurer": "AMBAC/SECONDARY AGC",
    "count": 6,
    "Abbreviation": "AMBAC"
  },
  {
    "bond_insurer": "AMBAC/SECONDARY BAM",
    "count": 26,
    "Abbreviation": "AMBAC"
  },
  {
    "bond_insurer": "AMBAC/SECONDARY BHAC",
    "count": 51,
    "Abbreviation": "AMBAC"
  },
  {
    "bond_insurer": "AMERICAN CAPITAL ACCESS",
    "count": 44,
    "Abbreviation": "ACA"
  },
  {
    "bond_insurer": "AMGC",
    "count": 1,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "Assured Guaranty",
    "count": 1,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "Assured Guaranty",
    "count": 1,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "ASSURED GUARANTY CORP FORMERLY ACE GTY",
    "count": 1515,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "ASSURED GUARANTY CORP FORMERLY RADIAN",
    "count": 147,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "ASSURED GUARANTY CORP (FORM RADIAN/FORM ASSET GTY)",
    "count": 20,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "ASSURED GUARANTY MUNICIPAL CORP",
    "count": 87290,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "BAM",
    "count": 4,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "BERKSHIRE HATHAWAY ASSURANCE CORP",
    "count": 40,
    "Abbreviation": "BHAC"
  },
  {
    "bond_insurer": "Build America",
    "count": 1,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "BUILD AMERICA",
    "count": 1,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "Build America Mutual",
    "count": 1,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "BUILD AMERICA MUTUAL",
    "count": 89153,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "CALIF HLTH FACS CONS LN-ST GTD",
    "count": 395,
    "Abbreviation": "CALIF"
  },
  {
    "bond_insurer": "FGIC",
    "count": 153,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/BHAC",
    "count": 1,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/REINS BY NATL (FORM MBIA)/SECD AGMC FORM FSA",
    "count": 14,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/REINS BY NATL PUB FIN GUAR (FORM MBIA)",
    "count": 47,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/SECD MKT AGMC FORM FSA",
    "count": 20,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/SECD MKT NATL PUB FIN GUAR (FORM MBIA)",
    "count": 12,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/SECONDARY AGC",
    "count": 2,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/SECONDARY AMBAC",
    "count": 1,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/SECONDARY ASSURED GUARANTY CORP (FORM RADIAN)",
    "count": 8,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FGIC/SECONDARY BHAC",
    "count": 37,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "FIREMEN'S INS OF NEWARK/CONTL CAS INS",
    "count": 1,
    "Abbreviation": "FIREMEN'S INS OF NEWARK/CONTL CAS INS"
  },
  {
    "bond_insurer": "MUNICIPAL ASSURANCE CORP",
    "count": 12,
    "Abbreviation": "MAC"
  },
  {
    "bond_insurer": "NATIONAL PUBLIC FINANCE GUARANTEE CORP",
    "count": 3295,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "NATL (FORM MBIA)/SECD MKT AGMC FORM FSA/SECD BHAC",
    "count": 2,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "NATL (FORM MBIA)/SECD MKT BUILD AMERICA MUTUAL",
    "count": 42,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "NATL PUB FIN GUAR (FORM MBIA)/SECD AGMC FORM FSA",
    "count": 23,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "NATL PUB FIN GUAR (FORM MBIA)/SECD BHAC",
    "count": 25,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "NATL PUBLIC FINANCE GUARANTEE (FORM MBIA)",
    "count": 2112,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "PSF",
    "count": 1,
    "Abbreviation": "PSF"
  },
  {
    "bond_insurer": "SEC BAM",
    "count": 1,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "SECD BAM",
    "count": 2,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "SECD BUILD AMER",
    "count": 1,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "SECD MKT AGC/AGMC FORM FSA",
    "count": 1,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "SECD MKT AGC (RADIAN(ASSET GTY))/AGMC FORM FSA",
    "count": 2,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "SECD MKT AGMC FORM FSA",
    "count": 24,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "SECD MKT AGMC FORM FSA/FGIC/REINS BY NATL (MBIA)",
    "count": 1,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "SECD MKT AGMC FORM FSA/NATL (FORM MBIA)",
    "count": 6,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "SECD MKT AGMC FORM FSA/SECD MKT BHAC",
    "count": 3,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "SECD MKT ASSURED GTY CORP (FORM RADIAN/ASSET GTY)",
    "count": 5,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "SECD MKT ASSURED GUAR",
    "count": 1,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "SECD MKT ASSURED GUARANTY CORP (FORM RADIAN)",
    "count": 17,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "SECD MKT ASSURED GUARANTY MUNICIPAL CORP",
    "count": 1278,
    "Abbreviation": "AGMC"
  },
  {
    "bond_insurer": "SECD MKT FGIC/REINSURED BY NATL (FORM MBIA)",
    "count": 6,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "SECD MKT NATL (FORMERLY MBIA FORM BIG)",
    "count": 2,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "SECD MKT NATL (FORM MBIA)/AGMC FORM FSA (CGIC)",
    "count": 2,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "SECD MKT NATL PUBLIC FIN GUAR CORP",
    "count": 41,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "SECONDARY AGC FORMERLY CIFG",
    "count": 3,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "SECONDARY AMER CAP ACCESS",
    "count": 6,
    "Abbreviation": "ACA"
  },
  {
    "bond_insurer": "SECONDARY ASSURED GUARANTY CORP (ACE GTY)",
    "count": 46,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "SECONDARY BERKSHIRE HATHAWAY ASSURANCE",
    "count": 15,
    "Abbreviation": "BHAC"
  },
  {
    "bond_insurer": "SECONDARY BUILD AMER",
    "count": 1,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "SECONDARY BUILD AMERICA MUTUAL",
    "count": 2839,
    "Abbreviation": "BAM"
  },
  {
    "bond_insurer": "SECONDARY MKT AGC FORMERLY CIFG REINSURED AGC",
    "count": 14,
    "Abbreviation": "AGC"
  },
  {
    "bond_insurer": "SECONDARY MKT AMBAC",
    "count": 19,
    "Abbreviation": "AMBAC"
  },
  {
    "bond_insurer": "SECONDARY MKT AMBAC/NATL (FORM MBIA)",
    "count": 1,
    "Abbreviation": "AMBAC/NATL"
  },
  {
    "bond_insurer": "SECONDARY MKT CAP MAC",
    "count": 1,
    "Abbreviation": "MAC"
  },
  {
    "bond_insurer": "SECONDARY MKT FGIC",
    "count": 16,
    "Abbreviation": "FGIC"
  },
  {
    "bond_insurer": "SECONDARY MKT FGIC/NATL (FORMERLY MBIA)",
    "count": 2,
    "Abbreviation": "FGIC/NATL"
  },
  {
    "bond_insurer": "SECONDARY MKT NATL (FORMERLY MBIA)",
    "count": 161,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "SECONDARY MKT SYNCORA GUAR INC (FORM XLCA)",
    "count": 12,
    "Abbreviation": "SYNCORA"
  },
  {
    "bond_insurer": "SYNCORA (FORM XLCA)/SEC MKT NATL (FORM MBIA)",
    "count": 2,
    "Abbreviation": "NATL"
  },
  {
    "bond_insurer": "SYNCORA GUARANTEE INC",
    "count": 8,
    "Abbreviation": "SYNCORA"
  },
  {
    "bond_insurer": "SYNCORA GUARANTEE INC (FORMERLY XLCA)",
    "count": 62,
    "Abbreviation": "SYNCORA"
  },
  {
    "bond_insurer": "SYNCORA GUAR INC (FORM XLCA)/SECD AGMC FORM  FSA",
    "count": 2,
    "Abbreviation": "SYNCORA"
  },
  {
    "bond_insurer": "SYNCORA GUAR INC (FORM XLCA)/SECONDARY AGC",
    "count": 1,
    "Abbreviation": "SYNCORA"
  }
]